/*
 * 戒导航 · 知识库审核（jiedh/wiki-review）—— 前端「审核回执」模型
 *
 * 设计依据：doc/知识库内容审核设计方案.md §7.3。
 *
 * ★ 为什么必须有这个文件（这是「通知内容空白」的根因修复）：
 *   通知 API 返回的关系是
 *       relationships.subject = { type: 'wikiReviewReceipts', id: '1' }
 *   而 Flarum 前端的本地数据仓库 app.store **只接受已注册的 type**：
 *       vendor/flarum/core/js/src/common/Store.ts → pushObject()
 *       if (!this.models[data.type]) { ...; return null; }   // ← 未注册：资源被静默丢弃
 *   接着 vendor/flarum/core/js/src/common/Model.ts → hasOne()
 *       if (relationshipData) return this.store.getById(relationshipData.type, relationshipData.id);
 *   getById 查不到（因为压根没进 store）⇒ 返回 undefined ⇒ notification.subject() === undefined
 *   ⇒ vendor/flarum/core/js/src/forum/components/NotificationList.js:82
 *       if (typeof subject === 'undefined') return;   // ← 整条通知被丢弃
 *   ⇒ 通知下拉面板看不到任何审核结果。所以必须在前端注册同名 type 的模型类。
 *
 * 属性与后端一一对应（**全部只读**：回执是「凭证」，客户端不允许改写）：
 *   JieDH\WikiReview\Api\Resource\WikiReviewReceiptResource::fields()
 *   type 名 'wikiReviewReceipts' 必须与 WikiReviewReceiptResource::type() 完全一致。
 *
 * 范本：packages/review/js/src/forum/models/ModerationReceipt.ts。
 *
 * 注意：本模型**不暴露 `discussion` 关系**（知识库文章不属于任何讨论），
 *   所以通知会落进前端的「中立分组」（标题显示论坛名）—— 这是预期行为，
 *   与后端 WikiReviewReceiptResource 的刻意取舍一致。
 */
import Model from 'flarum/common/Model';

/**
 * 审核回执。属性名与 API 的 attributes 同名（驼峰），由该资源直接输出。
 */
export default class WikiReviewReceipt extends Model {
  /**
   * 审核结论：approved / rejected。
   * 与后端 WikiReviewReceipt::ACTION_APPROVED / ACTION_REJECTED 常量一致。
   */
  action() {
    return Model.attribute('action').call(this);
  }

  /** 被审核文章 ID（文章已删除时该 ID 仅作留痕）。 */
  articleId() {
    return Model.attribute('articleId').call(this);
  }

  /**
   * 文章标题的**快照**。刻意存快照而非关联查询：
   * 文章被草稿化 / 删除后，回执仍要能说清「你的哪篇文章被处理了」。
   */
  articleTitle() {
    return Model.attribute('articleTitle').call(this);
  }

  /** 驳回理由原文（可选）。通过时为 null。 */
  reasonText() {
    return Model.attribute('reasonText').call(this);
  }

  /** 回执生成时间。 */
  createdAt() {
    return Model.attribute('createdAt', value => value ? new Date(value) : null).call(this);
  }
}
flarum.reg.add('jiedh-wiki-review', 'forum/models/WikiReviewReceipt', WikiReviewReceipt);